export default __webpack_public_path__ + "img/a5e75a02020da2dd906070045c74619d.png";